import request from 'axios';
import ReactOnRails from 'react-on-rails';
import merge from 'lodash/merge';

export default {
  /**
   * Retrieve an entity from server using AJAX call.
   *
   * @returns {Promise} - Result of ajax call.
   */
  fetchEntity(url) {
    return request({
      method: 'GET',
      url,
      responseType: 'json',
    });
  },

  get(url, config = {}) {
    return request(
      merge(
        {
          method: 'GET',
          url,
          responseType: 'json',
        },
        config
      )
    );
  },

  /**
   * Retrieve list of entities from server using AJAX call.
   *
   * @returns {Promise} - Result of ajax call.
   */
  fetchEntities(url) {
    return request({
      method: 'GET',
      url,
      responseType: 'json',
    });
  },

  /**
   * Update entity to server using AJAX call.
   *
   * @param {String} url - Url to send request.
   * @param {Object} entity - Request body to post.
   * @returns {Promise} - Result of ajax call.
   */
  updateEntity(url, entity) {
    return request({
      method: 'PATCH',
      url,
      responseType: 'json',
      headers: ReactOnRails.authenticityHeaders(),
      data: entity,
    });
  },

  delete(url, config = {}) {
    return request(
      merge(
        {
          method: 'DELETE',
          url,
          responseType: 'json',
          headers: ReactOnRails.authenticityHeaders(),
        },
        config
      )
    );
  },

  patch(url, data, config = {}) {
    return request(
      merge(
        {
          method: 'PATCH',
          url,
          responseType: 'json',
          headers: ReactOnRails.authenticityHeaders(),
          data,
        },
        config
      )
    );
  },

  post(url, object, config = {}) {
    return request(
      merge(
        {
          method: 'POST',
          url,
          responseType: 'json',
          headers: ReactOnRails.authenticityHeaders(),
          data: object,
        },
        config
      )
    );
  },

  deleteEntity(url) {
    return request({
      method: 'DELETE',
      url,
      responseType: 'json',
      headers: ReactOnRails.authenticityHeaders(),
    });
  },

  submitEntity(url, method, entity) {
    return request({
      method,
      url,
      responseType: 'json',
      headers: ReactOnRails.authenticityHeaders(),
      data: entity,
    });
  },

  postToSlack(host, channel, title, text = null, color = null) {
    return request({
      method: 'POST',
      url: host ? `http://${host}/post_to_slack` : '/post_to_slack',
      responseType: 'json',
      headers: ReactOnRails.authenticityHeaders(),
      data: { slack_params: { channel, title, text, color } },
    });
  },
};
